import React, { useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import imageUpload, { imageType } from "../../../methods/imageUpload"
import { message } from "antd"
import { useHistory } from "react-router-dom"
import { TOPBAR_HEIGHT } from "../../../data/style"
import playIconWhite from "../../../images/play-icon-white.svg"
import pauseIconWhite from "../../../images/pause-icon-white.svg"

// 容器样式
const Container = styled.div`
  top: ${TOPBAR_HEIGHT}px;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  background-color: #f8f8f8;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

// 主内容区域
const MainContent = styled.div`
  flex: 1;
  padding: 20px 40px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

// 标题区域
const TitleSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  min-height: 50px;
`

const MainTitle = styled.h1`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  color: #333;
  font-weight: bold;
  margin: 0;
`

const BackButton = styled.div`
  background: #fff;
  border: 1px solid #eee;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  padding: 10px 20px;
  border-radius: 50px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
/*   
  &:hover {
    background: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  } */
`

// AI说明
const AiNotice = styled.div`
  text-align: center;
  margin-bottom: 16px;
  
  .ai-note {
    font-size: 14px;
    color: #666;
  }
`

// 新增横屏主体布局
const MainLayout = styled.div`
  display: flex;
  gap: 40px;
  align-items: stretch;
  flex: 1;
  max-height: calc(100vh - ${TOPBAR_HEIGHT}px - 120px);
  overflow: hidden;
`

const LeftPanel = styled.div`
  flex: 0 0 auto;
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow: auto;
`

// 提示区域
const TipsSection = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  min-height: 200px;
`

const TipItem = styled.div`
  margin-bottom: 24px;
  line-height: 1.6;
  
  &:last-child {
    margin-bottom: 0;
  }
`

const TipLabel = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: bold;
`

const TipText = styled.span`
  font-size: 14px;
  color: #666;
  margin-left: 8px;
`

// 文本内容区域
const TextContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  min-height: 120px;
  max-height: 200px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  flex: 1;
  overflow: auto;
`

const ContentText = styled.div`
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  text-align: justify;
`

// 底部操作区域
const BottomActions = styled.div`
  padding: 20px 32px 40px;
  margin-top: auto;
`

// 准备上传状态
const ReadySection = styled.div`
  text-align: center;
`

const ActionButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`

const UploadLabel = styled.label`
  padding: 16px 32px;
  border: 2px solid var(--theme-main);
  border-radius: 25px;
  background: white;
  color: var(--theme-main);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-block;
  
  &:hover {
    background: var(--theme-main);
    color: white;
  }
  
  input {
    display: none;
  }
`

// 处理中状态
const ProcessingSection = styled.div`
  text-align: center;
`

const ProcessingTip = styled.div`
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 32px;
`

const ProcessingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

// 完成状态
const CompleteSection = styled.div`
  text-align: center;
`

const CompleteTop = styled.div`
  margin-bottom: 32px;
`

const CompleteTip = styled.div`
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
`

const CompleteDesc = styled.div`
  font-size: 14px;
  color: #666;
`

const CompleteButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
`

const PlaySection = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const PlayBtn = styled.div`
  width: 60px;
  height: 60px;
  background: var(--theme-main);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &.playing {
    background: #ff4757;
  }
`

const PlayIcon = styled.div`
  img {
    width: 24px;
    height: 24px;
  }
`

const ActionButton = styled.button`
  padding: 12px 24px;
  border: 1px solid var(--theme-main);
  border-radius: 25px;
  background: white;
  color: var(--theme-main);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: var(--theme-main);
    color: white;
  }
  
  &.primary {
    background: var(--theme-main);
    color: white;
    
    &:hover {
      background: var(--theme-main-hover-deep);
    }
  }
  
  &.danger {
    border-color: #ff4757;
    color: #ff4757;
    
    &:hover {
      background: #ff4757;
      color: white;
    }
  }
`

// 错误状态
const ErrorSection = styled.div`
  text-align: center;
`

const ErrorTip = styled.div`
  font-size: 14px;
  color: #ff4757;
  margin-bottom: 24px;
`

// 转换后的文字显示区域
const TranscriptionSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`

const TranscriptionTitle = styled.div`
  font-size: 12px;
  color: #333;
  font-weight: bold;
  margin-bottom: 8px;
`

const TranscriptionText = styled.div`
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  min-height: 40px;
  border-left: 3px solid var(--theme-main);
`

interface VoiceClonePageProps {
  user?: any;
}

function VoiceClonePage(props: VoiceClonePageProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const history = useHistory()
  
  const [uploadStatus, setUploadStatus] = useState<'ready' | 'processing' | 'complete' | 'error'>('ready')
  const [selectedAudio, setSelectedAudio] = useState<imageType | null>(null)
  const [originalFile, setOriginalFile] = useState<File | null>(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [audioElement, setAudioElement] = useState<HTMLAudioElement | null>(null)
  const [transcriptionText, setTranscriptionText] = useState('')

  const contentText = "看着窗外缓缓下落的雨滴，滴答声成了最好的背景音乐，拿起笔，写下了心中的所思所想，雨天也有独特的韵味。"

  // 处理音频选择和语音转文字
  const handleAudioUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (!files || files.length === 0) return

    const file = files[0]
    
    // 检查文件类型
    if (!file.type.startsWith('audio/')) {
      messageApi.error('请选择音频文件')
      return
    }

    // 检查文件大小 (限制为10MB)
    if (file.size > 10 * 1024 * 1024) {
      messageApi.error('音频文件大小不能超过10MB')
      return
    }

    // 保存原始文件和预览URL
    const audioUrl = URL.createObjectURL(file)
    setOriginalFile(file)
    setSelectedAudio({
      uid: 0,
      src: audioUrl,
      url: audioUrl,
      size: file.size,
      id: '',
      filename: file.name
    })
    
    setUploadStatus('processing')
    
    // 开始语音转文字处理
    performSpeechRecognition(file)
  }

  // 执行语音识别
  const performSpeechRecognition = (file: File) => {
    imageUpload<{ 
      msg: string; 
      res_id: string; 
      url: string;
      result?: string;
      status?: number;
      filename?: string;
    }>(file, "ipMp3SpeechRecognition", "语音识别中...")
      .then((res) => {
        console.log("speech recognition result:", res)
        if (res.res_id === "err") {
          setUploadStatus('error')
          messageApi.error(res.result || '语音识别失败')
        } else {
          // 检查识别状态
          if (res.status === 3) {
            // 识别失败
            setUploadStatus('error')
            messageApi.error(res.result || '语音识别失败，请重试')
          } else if (res.status === 2) {
            // 还在处理中，可能需要轮询
            messageApi.info('语音识别处理中，请稍候...')
            // 这里可以添加轮询逻辑，暂时先等待
            setTimeout(() => {
              setUploadStatus('error')
              messageApi.error('语音识别超时，请重试')
            }, 30000) // 30秒超时
          } else if (res.status === 1 && res.result) {
            // 识别成功
            setTranscriptionText(res.result)
            setUploadStatus('complete')
            messageApi.success('语音识别完成')
          } else {
            // 未知状态
            setUploadStatus('error')
            messageApi.error(res.result || '语音识别状态异常，请重试')
          }
        }
      })
      .catch((error) => {
        console.error("speech recognition error:", error)
        setUploadStatus('error')
        messageApi.error('语音识别请求失败，请重试')
      })
  }

  // 播放/暂停音频
  const togglePlay = () => {
    if (!selectedAudio?.url) return

    if (!audioElement) {
      const audio = new Audio(selectedAudio.url)
      audio.onended = () => setIsPlaying(false)
      audio.onpause = () => setIsPlaying(false)
      audio.onplay = () => setIsPlaying(true)
      setAudioElement(audio)
      audio.play()
    } else {
      if (isPlaying) {
        audioElement.pause()
      } else {
        audioElement.play()
      }
    }
  }

  // 重新录制/上传
  const retry = () => {
    setUploadStatus('ready')
    setSelectedAudio(null)
    setOriginalFile(null)
    setIsPlaying(false)
    setTranscriptionText('')
    if (audioElement) {
      audioElement.pause()
      setAudioElement(null)
    }
  }

  // 确认上传并开始声音克隆
  const confirmUpload = () => {
    if (!originalFile || !selectedAudio) return
    
    messageApi.info('开始上传声音克隆...')
    
    imageUpload<{ msg: string; res_id: string; url: string }>(originalFile, "ipmp3", "声音克隆中")
      .then((res) => {
        console.log("voice clone upload result:", res)
        if (res.res_id === "err") {
          messageApi.error(res.msg)
        } else {
          messageApi.success(res.msg)
          setTimeout(() => {
            history.goBack()
          }, 1500)
        }
      })
      .catch((error) => {
        console.error("voice clone upload error:", error)
        messageApi.error('声音克隆上传失败，请重试')
      })
  }

  // 返回上一页
  const goBack = () => {
    history.goBack()
  }

  return (
    <>
      {contextHolder}
      <Container>
        <MainContent>
          {/* 标题区域 */}
          <TitleSection>
            <BackButton onClick={goBack}>返回上一页</BackButton>
            <MainTitle>声音克隆</MainTitle>
          </TitleSection>

          {/* AI训练说明 */}
          <AiNotice>
            <div className="ai-note">上传的音频将用于AI训练</div>
          </AiNotice>

          {/* 横屏主体布局 */}
          <MainLayout>
            {/* 左侧提示面板 */}
            <LeftPanel>
              <TipsSection>
                <TipItem>
                  <TipLabel>提示1:</TipLabel>
                  <TipText>请等待一个安静2秒，以清晰且缓慢流畅的方式，逐字朗读下方文字。</TipText>
                </TipItem>
                <TipItem>
                  <TipLabel>提示2:</TipLabel>
                  <TipText>你希望AI生成的声音如何表达，就以相应的方式朗读文字。如：温柔、和谐、激昂、俏皮等等。</TipText>
                </TipItem>
              </TipsSection>
            </LeftPanel>

            {/* 右侧内容面板 */}
            <RightPanel>
              {/* 文本内容区域 */}
              <TextContent>
                <ContentText>{contentText}</ContentText>
              </TextContent>

              {/* 语音转文字结果 */}
              {transcriptionText && (
                <TranscriptionSection>
                  <TranscriptionTitle><span role="img" aria-label="target">🎯</span> 语音识别结果：</TranscriptionTitle>
                  <TranscriptionText>{transcriptionText}</TranscriptionText>
                </TranscriptionSection>
              )}
            </RightPanel>
          </MainLayout>
        </MainContent>

        {/* 底部操作区域 */}
        <BottomActions>
          {/* 准备上传状态 */}
          {uploadStatus === 'ready' && (
            <ReadySection>
              <ActionButtons>
                <UploadLabel>
                  <input 
                    type="file" 
                    accept=".mp3,.wav,.m4a,.pcm,audio/*" 
                    onChange={handleAudioUpload} 
                  />
                  选择音频
                </UploadLabel>
              </ActionButtons>
            </ReadySection>
          )}

          {/* 处理中状态 */}
          {uploadStatus === 'processing' && (
            <ProcessingSection>
              <ProcessingTip>正在进行语音识别...</ProcessingTip>
              <ProcessingSpinner>
                <Spinner />
              </ProcessingSpinner>
            </ProcessingSection>
          )}

          {/* 完成状态 */}
          {uploadStatus === 'complete' && selectedAudio && (
            <CompleteSection>
              <CompleteTop>
                <CompleteTip>处理完毕</CompleteTip>
                <CompleteDesc>{selectedAudio.filename}</CompleteDesc>
              </CompleteTop>
              <CompleteButtons>
                <PlaySection onClick={togglePlay}>
                  <PlayBtn className={isPlaying ? 'playing' : ''}>
                    <PlayIcon>
                      <img src={isPlaying ? pauseIconWhite : playIconWhite} alt={isPlaying ? 'pause' : 'play'} />
                    </PlayIcon>
                  </PlayBtn>
                </PlaySection>
                <ActionButton className="primary" onClick={confirmUpload}>确认上传</ActionButton>
                <ActionButton onClick={retry}>重新上传</ActionButton>
              </CompleteButtons>
            </CompleteSection>
          )}

          {/* 错误状态 */}
          {uploadStatus === 'error' && (
            <ErrorSection>
              <ErrorTip>提示：音频不符合标准</ErrorTip>
              <ActionButton className="danger" onClick={retry}>重新上传</ActionButton>
            </ErrorSection>
          )}
        </BottomActions>
      </Container>
    </>
  )
}

const mapStateToProps = (state: any) => ({
  user: state.login_user_data,
})

export default connect(mapStateToProps)(VoiceClonePage)